import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import useStyles from '../ContactCell.style';
import PropTypes from 'prop-types';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton, Tooltip } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { deleteCritic, getShortCritic } from 'redux/actions/CriticsManager';

const DownloadItemCell = ({ critic }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const classes = useStyles();
  const history = useHistory();

  const params = new URLSearchParams(location.search);

  const movieId = params.get('movie');

  const { id } = critic;

  const handleDelete = () => {
    dispatch(deleteCritic(movieId, id));
  };

  const handleGoToUpdate = () => {
    dispatch(getShortCritic(movieId, id, history));
  };

  return (
    <TableRow className={classes.tableRowRoot}>
      <TableCell className={classes.tableCellRoot}>
        <Box display="flex" alignItems="center">
          <Typography className={classes.titleRoot} component="div" variant="h4">
            {id}
          </Typography>
        </Box>
      </TableCell>
      <TableCell className={classes.tableCellRoot} style={{ textAlign: 'end' }}>
        <Tooltip title="ویرایش">
          <IconButton size="small" target="_blank" onClick={handleGoToUpdate}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="حذف">
          <IconButton size="small" target="_blank" onClick={handleDelete}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default DownloadItemCell;

DownloadItemCell.prototype = {
  contact: PropTypes.object.isRequired,
  onShowContactDetail: PropTypes.func,
};
